import { render, staticRenderFns } from "./ErrorContaExpirada.vue?vue&type=template&id=1985697a&scoped=true&"
import script from "./ErrorContaExpirada.vue?vue&type=script&lang=js&"
export * from "./ErrorContaExpirada.vue?vue&type=script&lang=js&"
import style0 from "./ErrorContaExpirada.vue?vue&type=style&index=0&id=1985697a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1985697a",
  null
  
)

export default component.exports